import Flex from 'legacyfrontend/components/Flex';
import { PACKAGE_CARD_TABS_KEYS } from 'legacyfrontend/constants';
import { usePackageCard } from 'legacyfrontend/contexts/PackageCardContext';
import FlightsInfo from '../FlightsInfo';
import HotelsInfo from '../HotelsInfo';
import InfoHeader from './components/InfoHeader';
import LoadSpinner from 'legacyfrontend/components/spinner';
import { useMemo, useRef, useEffect, useState } from 'react';
import { Box, Typography, Button } from '@mui/material';
import WarningOutlinedIcon from '@mui/icons-material/WarningOutlined';
import RefreshIcon from '@mui/icons-material/Refresh';

const { HOTELS, FLIGHTS } = PACKAGE_CARD_TABS_KEYS;

const LoadingErrorAlert = ({ message, onRetry }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1,
        p: 2,
        borderRadius: '15px',
        mb: 2,
        mt: 2,
      }}
    >
      <WarningOutlinedIcon sx={{ color: '#6B6B47' }} />
      <Typography sx={{ color: '#6B6B47', flex: 1 }} variant='body2'>
        {message}
      </Typography>
      <Button
        onClick={onRetry}
        size='small'
        startIcon={<RefreshIcon />}
        sx={{ color: '#6B6B47', borderColor: '#6B6B47' }}
        variant='outlined'
      >
        Reintentar
      </Button>
    </Box>
  );
};

const DynamicContent = () => {
  const containerRef = useRef(null);
  const [localError, setLocalError] = useState(null);
  const {
    selectedTab,
    displayInfo,
    departureDatesIsLoading,
    packageConfigurationsIsLoading,
    packageConfigurationsIsFetching,
    error,
    setError,
    fetchDepartureDates,
    fetchPackageConfigurations,
  } = usePackageCard();

  const tabs = useMemo(
    () => ({
      [FLIGHTS]: <FlightsInfo />,
      [HOTELS]: <HotelsInfo containerRef={containerRef} />,
    }),
    [containerRef]
  );

  useEffect(() => {
    if (error) {
      setLocalError(error);
    }
  }, [error]);

  const handleRetry = () => {
    setLocalError(null);
    setError(null);
    if (selectedTab === FLIGHTS) {
      fetchDepartureDates();
    } else {
      fetchPackageConfigurations();
    }
  };

  const isLoading =
    !localError &&
    (departureDatesIsLoading || packageConfigurationsIsLoading || packageConfigurationsIsFetching);

  return displayInfo ? (
    <div className='flex flex-col package-card__dynamic-content' ref={containerRef}>
      <InfoHeader tabs={Object.keys(tabs)} />
      <Flex className='package-card__dynamic-content__wrapper' vertical>
        {isLoading ? (
          <LoadSpinner style={{ marginTop: 20, marginBottom: 20 }} />
        ) : localError ? (
          <LoadingErrorAlert message={localError} onRetry={handleRetry} />
        ) : (
          tabs[selectedTab]
        )}
      </Flex>
    </div>
  ) : null;
};

export default DynamicContent;
